export default __webpack_public_path__ + "static/magalog-9ec76c6f7f211438b6f956c51b67ea0a.png";